import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\AboutOverview.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\home\\DropRequirements.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\home\\FeatureSlider.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\home\\HomeBanner.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\media\\MediaSlider.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\service\\ServiceListing.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\components\\Testimonial.jsx");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\node_modules\\next\\dist\\shared\\lib\\lazy-dynamic\\dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "C:\\projects\\ups-updated-2026\\node_modules\\next\\dist\\shared\\lib\\lazy-dynamic\\preload-css.js");
